<script setup lang="ts">
withDefaults(defineProps<{ data?: string[] }>(), {
  data: () => [],
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['editor-about-section', { _mobile: isMobile }]">
    <div class="editor-about-section__title">Об авторе</div>
    <div class="editor-about-section__description">
      <p
        v-for="(item, index) in data"
        :key="index"
        class="editor-about-section__description-item"
      >
        {{ item }}
      </p>
    </div>
  </div>
</template>

<style lang="less">
.editor-about-section {
  .flex-column(@size-x6);
  .box-shadow();

  padding: @size-x8;
  border-radius: @main-size;

  &__title {
    font-size: 30px;
    font-weight: 700;
    line-height: 130%;
  }

  &__description {
    .flex-column(@size-x4);

    font-size: @size-x4;
    font-weight: 600;
    line-height: 130%;
  }

  &._mobile {
    padding: @size-x6;
  }
}
</style>
